import { ModalComponent as PickerModal } from './Components/Modal';
export default PickerModal;
//# sourceMappingURL=index.js.map